export const GET_BUSINESS_AREA_SUCCES = 'GET_BUSINESS_AREA_SUCCESS';
export const GET_BUSINESS_AREA_FAILED = 'GET_BUSINESS_AREA_FAILED';
export const GET_ALL_REQUEST = 'GET_ALL_REQUEST';
